export class Paging {
    itemsPerPage: number | undefined;
    pageNumber: number | undefined;
    pagination: number | undefined;
    isAllWords: boolean | undefined;
}
